
export const AUTH_SIGNIN = '[AUTH] SIGNIN';
export const AUTH_TOKEN = '[AUTH] TOKEN';
export const AUTH_SUCCESS = '[AUTH] SUCCESS';
export const SIGNOUT_SUCCESS = '[AUTH] SIGNOUT SUCCESS';
export const AUTH_FAIL = '[AUTH] FAIL';
export const AUTH_SIGNOUT = '[AUTH] SIGNOUT';
